'use client';

import { useContext } from 'react';
import { AuthDrawerContext } from '../../context';
import type { AuthDrawerContextValue } from '../../types';

const useAuthDrawer = (): AuthDrawerContextValue => {
  const ctx = useContext(AuthDrawerContext);
  if (!ctx) {
    throw new Error('useAuthDrawer must be used within an AuthDrawerProvider');
  }
  return ctx;
};

export default useAuthDrawer;
